import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseAvatarSize, BaseButtonSize, CustomerBranchListItemResponse } from 'base';

@Component({
  selector: 'base-customer-provider-list-item',
  templateUrl: './base-customer-provider-list-item.component.html',
})
export class BaseCustomerProviderListItemComponent {
  @Input() provider: CustomerBranchListItemResponse;
  @Output() openIZSInfo: EventEmitter<{ event: Event; data: CustomerBranchListItemResponse }> = new EventEmitter<{
    event: Event;
    data: CustomerBranchListItemResponse;
  }>();

  buttonSize = BaseButtonSize;
  avatarSize = BaseAvatarSize;

  onIZSInfoOpen(event: Event): void {
    this.openIZSInfo.emit({ event, data: this.provider });
  }
}
